import {
  CoreResponsiveTable,
  type PropsWithOptionalTestID,
} from "@boi/components-core";

import * as S from "./ResponsiveTable.styled";
import { StandardTable } from "./StandardTable";
import { CompactTable } from "./CompactTable";
import { type TableProps } from "../Table";

type Header = CoreResponsiveTable.Header;
type Row = CoreResponsiveTable.Row;

export type ResponsiveTableProps = PropsWithOptionalTestID & {
  minWidth: number;
  compactLayout?: TableProps["layout"];
  standardLayout?: TableProps["layout"];
  headers: [Header, Header, ...Header[]];
  rows: [Row, ...Row[]];
};

function ResponsiveTable(props: ResponsiveTableProps) {
  const { minWidth, testID = "responsive-table", ...otherProps } = props;
  const { headers, rows } = otherProps;

  if (!CoreResponsiveTable.isDataValid(headers, rows)) {
    console.warn("Invalid responsive table data");
    return null;
  }

  return (
    <S.Container data-testid={testID}>
      <S.CompactTableWrapper $minWidth={minWidth}>
        <CompactTable {...otherProps} testID={testID} />
      </S.CompactTableWrapper>

      <S.StandardTableWrapper $minWidth={minWidth}>
        <StandardTable {...otherProps} testID={testID} />
      </S.StandardTableWrapper>
    </S.Container>
  );
}

export default ResponsiveTable;
